<template>
  <div class="calories-selector-v4">
    <p
      v-if="isTitleVisible"
      class="calories-selector-v4__title"
    >
      Калорий в день
    </p>
    <Swiper
      :slides-per-view="slidesPerView"
      centered-slides
      centered-slides-bounds
      :initial-slide="3"
      class="calories-selector-v4__swiper"
      @touchMove="onTouchMove"
      @swiper="setSwiper"
    >
      <SwiperSlide
        v-for="menuType in menuTypes"
        :key="menuType.type"
      >
        <CoreButton
          class="calories-selector-v4__btn"
          :class="getButtonClasses(menuType)"
          :type="getButtonType(menuType)"
          @click="selectMenuType($event, menuType)"
        >
          <span class="calories-selector-v4__text">
            {{ menuType.byCaloriesLabelTitleMobile }}
          </span>
          <br>
          <span
            class="calories-selector-v4__sub-text"
            :class="getTextClasses(menuType)"
          >
            {{ menuType.byCaloriesLabelSubtitleMobile }}
          </span>
        </CoreButton>
        <div
          class="calories-selector-v4__arrow-line"
          :class="`calories-selector-v4__arrow-line--${menuType.type}`"
        >
          <div
            v-if="isArrowVisible(menuType)"
            class="calories-selector-v4__arrow-from-border"
          />
        </div>
        <div
          class="calories-selector-v4__arrow-line-bottom"
          :class="`calories-selector-v4__arrow-line-bottom--${menuType.type}`"
        >
          <p
            v-if="isArrowTextVisible(menuType)"
            class="calories-selector-v4__arrow-text"
            :style="{ color: getArrowText(menuType).color }"
          >
            {{ getArrowText(menuType).text }}
          </p>
        </div>
      </SwiperSlide>
      <div
        v-if="!isSwiperMoving"
        class="calories-selector-v4__arrow-from-polygon"
      />
    </Swiper>
  </div>
</template>

<script>
import CoreButton from '@/components/core/ui/CoreButton'
import { Swiper, SwiperSlide } from 'swiper/swiper-vue'
// constants
import {
  CALORIES,
  HIGH,
} from '@/config/constants'

const BUTTON_COLORS_BY_MENU_TYPE = {
  detox: 'dodger-blue',
  power: 'pomegranat',
  balance: 'supernova',
  m_fit: 'key-lime-pie',
  daily: 'sushi',
  fit: 'mantis',
  basic: 'emerald',
  super_fit: 'emerald',
  fit_express: 'shamrock',
  econom_1000: 'mantis',
  econom_1500: 'sushi',
  econom_2000: 'supernova',
  light_1400: 'sushi',
  strong_1800: 'supernova',
}

const ARROW_OFFSET = 9
const ARROW_COLORS_BY_MENU_TYPE = {
  detox: '#28ABFB',
  power: '#F34E1E',
  balance: '#FDC802',
  m_fit: '#BEC725',
  daily: '#84C645',
  fit: '#63C657',
  basic: '#3EC66B',
  breakfasts_2x: '#3EC66B',
  super_fit: '#3EC66B',
  fit_express: '#2EB9B2',
  econom_1000: '#63C657',
  econom_1500: '#84C645',
  econom_2000: '#FDC802',
  light_1400: '#84C645',
  strong_1800: '#FDC802',
}

const MENU_TYPES_WITH_ARROW_TEXT = {
  detox: 'Очищение',
  fit: 'Снижение веса',
  balance: 'Баланс',
  power: 'Набор',
  econom_1000: 'Снижение веса',
  econom_1500: 'Баланс',
  econom_2000: 'Набор',
  strong_1800: 'Баланс',
}
const DEFAULT_MENU_TYPE = 'daily'

export default {
  name: 'CaloriesSelector',

  components: {
    CoreButton,
    Swiper,
    SwiperSlide,
  },

  props: {
    isTitleVisible: {
      type: Boolean,
      default: true,
    },
    menuTypes: {
      required: true,
      type: Array,
    },
    defaultMenuType: {
      type: String,
      default: '',
    },
  },

  emits: ['select'],

  data () {
    return {
      selectedMenuType: null,
      swiper: null,
      isSwiperMoving: true,
    }
  },

  computed: {
    slidesPerView () {
      return this.menuTypes.length > 5 ? 5.3 : this.menuTypes.length
    },
  },
  watch: {
    $route: {
      handler (route, oldRoute) {
        if (route.params?.goal !== oldRoute.params?.goal) {
          this.selectMenuTypeByRoute()
        }
      },
      deep: true,
    },
  },

  mounted () {
    this.selectMenuTypeByRoute()
    this.centerSelectedMenuType()
  },

  methods: {
    isArrowTextVisible (menuType) {
      const index = this.menuTypes.findIndex(mt => mt.type === menuType.type)
      if (index === 0) {
        return true
      }
      return MENU_TYPES_WITH_ARROW_TEXT[menuType.type]
    },

    getArrowText (menuType) {
      const index = this.menuTypes.findIndex(mt => mt.type === menuType.type)
      if (index === 0) {
        const firstMenuType = this.menuTypes[0]
        const color = BUTTON_COLORS_BY_MENU_TYPE[firstMenuType.type]
        return { text: 'Похудение', color }
      }
      const text = MENU_TYPES_WITH_ARROW_TEXT[menuType.type]
      return { text: text || '', color: '' }
    },

    isArrowVisible (menuType) {
      return (menuType.id === this.selectedMenuType?.id) && this.isSwiperMoving
    },

    getButtonClasses (menuType) {
      return {
        'calories-selector-v4__btn--detox': this.isDetox(menuType),
      }
    },

    getButtonType (menuType) {
      if (menuType.id !== this.selectedMenuType?.id) {
        return 'white-grey'
      }
      return BUTTON_COLORS_BY_MENU_TYPE[this.selectedMenuType.type]
    },

    onTouchMove () {
      this.isSwiperMoving = true
    },

    selectMenuType (event, menuType) {
      this.isSwiperMoving = false
      const target = event.target
      const selectedElementIndex = this.menuTypes.findIndex(mt => mt.type === menuType.type)
      this.swiper.slideTo(selectedElementIndex, 100, false)
      setTimeout(() => {
        const targetCoords = target.getBoundingClientRect()
        const offset = targetCoords.x + targetCoords.width / 2 - ARROW_OFFSET
        this.swiper.el.style.setProperty('--bg-offset', `${offset}px`)
        this.swiper.el.style.setProperty('--bg-color', ARROW_COLORS_BY_MENU_TYPE[menuType.type])

        this.selectedMenuType = menuType
        this.sendGTMMarkupEvent({
          block: 'new_order',
          element: 'menu',
          action: 'change',
        })

        this.$router.replace({
          ...this.$route,
          params: {
            ...this.$route.params,
            plan: menuType.type,
          },
        })
        this.$emit('select', menuType)
      }, 100)
    },

    getTextClasses (menuType) {
      return {
        'calories-selector-v4__sub-text--active': this.selectedMenuType?.id === menuType.id,
      }
    },

    selectMenuTypeByRoute () {
      let menuTypeFromRoute = this.$route.params.plan
      if (!menuTypeFromRoute) {
        menuTypeFromRoute = this.defaultMenuType
      }
      const menuType = this.menuTypes.find((menuType) => menuType.type === menuTypeFromRoute)
      if (menuType) {
        this.selectedMenuType = menuType
      } else {
        this.selectedMenuType = this.menuTypes.find((menuType) => menuType.type === DEFAULT_MENU_TYPE) || this.menuTypes[0]
      }
      if (this.$route.params.goal === HIGH || this.$route.params.goal === CALORIES) {
        this.$emit('select', this.selectedMenuType)
      }
    },

    setSwiper (swiper) {
      this.swiper = swiper
    },

    centerSelectedMenuType () {
      if (this.selectedMenuType?.type === DEFAULT_MENU_TYPE) {
        return
      }
      const selectedElementIndex = this.menuTypes.findIndex(
        (menuType) => menuType === this.selectedMenuType,
      )
      this.swiper.slideTo(selectedElementIndex, 300, false)
    },

    isDetox (menuType) {
      return menuType.type === 'detox'
    },
  },
}
</script>

<style lang="scss">
.swiper.calories-selector-v4__swiper {
  margin: 0 -16px;
}

.swiper-slide {
  &:last-child .calories-selector-v4__btn {
    margin-right: 8px;
  }

  &:first-child .calories-selector-v4__btn {
    margin-left: 8px;
  }
}

.calories-selector-v4 {
  padding-top: 32px;
  $this: &;

  &__swiper {
    --bg-offset: 0%;
    --bg-color: white;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 16px;
  }

  &__btn {
    display: block;
    padding: 0;
    min-height: 48px;
    width: calc(100% - 12px);
    text-transform: none;
    border-radius: 16px;
    font-size: 12px;
    line-height: 14px;
    margin: 0 auto 16px;

    &--detox {
      font-size: 10px;
    }
  }

  &__text {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  &__sub-text {
    color: map-get($colors, 'grey_40');

    &--active {
      color: map-get($colors, 'white');
    }
  }

  &__arrow-line {
    height: 6px;
    margin: 0;
    position: relative;

    &--detox {
      background: linear-gradient(90deg, rgb(38, 168, 248), rgb(39, 170, 250), rgb(42, 175, 225));
      border-radius: 100px 0 0 100px;
      margin-left: 0;

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(39, 170, 250);
        }
      }
    }

    &--fit_express {
      background: linear-gradient(90deg, rgb(42, 175, 225), rgb(47, 185, 173), rgb(49, 193, 131));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(47, 185, 173);
        }
      }
    }

    &--super_fit, &--breakfasts_2x {
      background: linear-gradient(90deg, rgb(49, 193, 131), rgb(62, 197, 106), rgb(80, 197, 97));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(62, 197, 106);
        }
      }
    }

    &--fit {
      background: linear-gradient(90deg, rgb(80, 197, 97), rgb(98, 198, 87), rgb(115, 198, 79));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(98, 198, 87);
        }
      }
    }

    &--daily {
      background: linear-gradient(90deg, rgb(115, 198, 79), rgb(128, 190, 65), rgb(155, 197, 56));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(128, 190, 65);
        }
      }
    }

    &--m_fit {
      background: linear-gradient(90deg, rgb(155, 197, 56), rgb(182, 192, 35), rgb(220, 199, 19));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(182, 192, 35);
        }
      }
    }

    &--balance {
      background: linear-gradient(90deg, rgb(220, 199, 19), rgb(253, 199, 0), rgb(238, 124, 17));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(253, 199, 0);
        }
      }
    }

    &--power {
      background: linear-gradient(90deg, rgb(238, 124, 17), rgb(232, 75, 28), rgb(242, 78, 29));
      border-radius: 0 100px 100px 0;
      margin-right: 0;

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(232, 75, 28);
        }
      }
    }
    &--econom_1000 {
      background: linear-gradient(90deg, rgb(80, 197, 97), rgb(98, 198, 87), rgb(115, 198, 79));
      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(98, 198, 87);
        }
      }
    }
    &--econom_1500 {
      background: linear-gradient(90deg, rgb(115, 198, 79), rgb(128, 190, 65), rgb(220, 199, 19));
      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(128, 190, 65);
        }
      }
    }
    &--econom_2000 {
      background: linear-gradient(90deg, rgb(220, 199, 19), rgb(253, 199, 0), rgb(238, 124, 17));
      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(253, 199, 0);
        }
      }
    }
    &--light_1400 {
      background: linear-gradient(90deg, rgb(115, 198, 79), rgb(128, 190, 65), rgb(155, 197, 56));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(128, 190, 65);
        }
      }
    }
    &--strong_1800 {
      background: linear-gradient(90deg, rgb(220, 199, 19), rgb(253, 199, 0), rgb(238, 124, 17));

      & {
        #{$this}__arrow-from-border {
          border-bottom: 9px solid rgb(253, 199, 0);
        }
      }
    }
  }

  &__arrow-from-border {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    left: 0;
    right: 0;
    bottom: 6px;
    margin: 0 auto;
    z-index: -1;
  }

  &__arrow-from-polygon {
    width: 20%;
    height: 100%;
    background-color: var(--bg-color);
    position: absolute;
    top: 35px;
    left: var(--bg-offset);
    transition: left 1s;
    clip-path: polygon(0px 30px, 9px 20px, 18px 30px);
  }

  &__arrow-text {
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    white-space: nowrap;
    z-index: 2;
  }

  &__arrow-line-bottom {
    height: 27px;
    margin: -3px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding-top: 2px;

    &--detox {
      background: rgb(235, 246, 255);
      border-bottom-left-radius: 6px;
      margin-left: 0;
      color: #29ABFB;
    }

    &--fit_express {
      background: linear-gradient(90deg, rgb(235, 246, 255), rgb(236, 248, 245));
      color: #2EB9B2;
    }

    &--super_fit, &--breakfasts_2x {
      background: linear-gradient(90deg, rgb(236, 248, 245), rgb(239, 249, 240));
      color: #3EC66B;
    }

    &--fit {
      background: linear-gradient(90deg, rgb(239, 249, 240), rgb(242, 249, 238));
      color: #6AC654;
      padding-right: 20px;
    }

    &--daily {
      background: linear-gradient(90deg, rgb(242, 249, 238), rgb(244, 249, 236));
    }

    &--m_fit {
      background: linear-gradient(90deg, rgb(244, 249, 236), rgb(251, 249, 235));
    }

    &--balance {
      background: linear-gradient(90deg, rgb(251, 249, 235), rgb(255, 243, 234));
      color: #FEBE03;
    }

    &--power {
      background: linear-gradient(90deg, rgb(255, 243, 234), rgb(255, 237, 233));
      border-bottom-right-radius: 6px;
      margin-right: 0;
      color: #F24E1E;
    }

    &--econom_1000 {
      background: linear-gradient(90deg, rgb(239, 249, 240), rgb(242, 249, 238));
      color: #6AC654;
      padding-right: 20px;
    }
    &--econom_1500 {
      background: linear-gradient(90deg, rgb(242, 249, 238), rgb(244, 249, 236));
      color: #FEBE03;
    }
    &--econom_2000 {
      background: linear-gradient(90deg, rgb(251, 249, 235), rgb(255, 243, 234));
      color: #F24E1E;
    }
    &--light_1400 {
      background: linear-gradient(90deg, rgb(242, 249, 238), rgb(244, 249, 236));
    }
    &--strong_1800 {
      background: linear-gradient(90deg, rgb(251, 249, 235), rgb(255, 243, 234));
      color: #FEBE03;
    }
  }
}
</style>
